export enum BANNER_TYPES {
  BUSY_DAY = 'BUSY_DAY',
  CENTRAL_SORTING = 'CENTRAL_SORTING',
  NONE = 'NONE',
}
